import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost:8888/qbank/public/api', // backend base URL http://pustakques.webndro.com
  baseURL: 'https://pustakexam.webndro.com/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;